import axios from 'axios';
import authHeader from '../auth-header';
import { CardAddressDto } from '../../types/types';
import { API_URL } from '../../constants/api';

class CardAddressesService {
  getAddressesByCardId(cardId: string) {
    return axios.get<CardAddressDto[]>(
      `${API_URL}/cardAddresses/${cardId}`,
      { headers: authHeader() }
    );
  }

  createAddress(payload: {
    cardId: string;
    gymName?: string;
    gymAddress?: string;
    city?: string;
    countryId?: string;
  }) {
    return axios.post<CardAddressDto>(
      `${API_URL}/cardAddresses`,
      payload,
      { headers: authHeader() }
    );
  }
}

export default new CardAddressesService();